import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  })
);
interface Props {
  active: boolean;
  loadingType: 'fullscreen' | 'default';
}

const LoadingScreen = (props: Props) => {
  const classes = useStyles();

  if (props.active === false) return null;
  return (
    <Backdrop className={classes.backdrop} open={props.active}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
const defaultProps: Props = {
  active: false,
  loadingType: 'default',
};
LoadingScreen.defaultProps = defaultProps;

export default LoadingScreen;
